<template>
  <div>
    <!-- 发票信息 -->
    <div class="edit-card" style="margin-top:20px;padding-bottom:10px;">
      <div style="width:88%;display: flex">
        <div class="start-label" />
        <span class="text">发票信息</span>
      </div>
      <el-row>
        <el-col :span="6">
          <el-form-item label="发票代码" prop="billCode">
            <el-input
              :disabled="disabled"
              v-model="form.billCode"
              placeholder="根据财务部反写过来"
              style="width:90%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="发票号码" prop="billNo">
            <el-input
              :disabled="disabled"
              v-model="form.billNo"
              placeholder="根据财务部反写过来"
              style="width:90%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="发票金额" prop="billAmount">
            <el-input
              :disabled="disabled"
              v-model="form.billAmount"
              placeholder="根据财务部反写过来"
              style="width:90%"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
export default {
  components: {},
  /** 定义属性 */
  data() {
    return {
      form: {},
    };
  },
  props: {
    typeName: {
      type: String,
      default() {
        return "发票";
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    getBillCode() {
      return this.form.billCode;
    },
    getBillNo() {
      return this.form.billNo;
    },
    getBillAmount() {
      return this.form.billAmount;
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created() {},
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted() {},
  /** 生命周期 - 创建之前 */
  beforeCreate() {},
  /** 生命周期 - 挂载之前 */
  beforeMount() {},
  /** 生命周期 - 更新之前 */
  beforeUpdate() {},
  /** 生命周期 - 更新之后 */
  updated() {},
  /** 生命周期 - 销毁之前 */
  beforeDestroy() {},
  /** 生命周期 - 销毁完成 */
  destroyed() {},
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated() {},
};
</script>

<style lang="scss" scoped></style>
